import { select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';

import { getOpenPlatformSelectedProduct, getShowContractInputToggleFlag } from '@ordersnproducts/modules/order-builder/reducers/index';
import { BaseAsyncValue } from '../../../../shared/models/async-value';

export namespace ContractFormFieldOpenPlatformEnablerProvider {

  export class IsLoading extends BaseAsyncValue<Boolean> {
    getValue(): Observable<Boolean> {
      return this.store.pipe(
        select(getOpenPlatformSelectedProduct),
        map(selectedProduct => {
          if (selectedProduct) {
            const allUpdated = selectedProduct.contracts.every(contract => contract.remainingBalance !== undefined);
            return allUpdated === false;
          }
          return true;
        }),
        takeUntil(this.ngDestroy),
      );
    }
  }
}

export namespace ContractFormSelectShowToggle {

  export class EnableContractToggleFlag extends BaseAsyncValue<boolean> {
    getValue(): Observable<boolean> {
      return this.store.select(getShowContractInputToggleFlag).pipe(
        takeUntil(this.ngDestroy),
        map(showContract => {
          return showContract;
        }),
      );
    }
  }

}
